import { NgModule } from '@angular/core';
import {
    AdminCacheService,
    AdminClientCustomizationService,
    AdminDashboardService,
    AdminDashboardsExportImportService,
    AdminDataModelService,
    AdminETLStatusService,
    AdminExtendedDatasetManagerService,
    AdminFileUploadConfigService,
    AdminGainsightPXService,
    AdminJobInfoService,
    AdminOrganisationSecretService,
    AdminOrganisationService,
    AdminOrganisationSettingsService,
    AdminProductService,
    AdminProductUpgradeService,
    AdminProductVersionService,
    AdminService,
    AdminSiteContentService,
    AdminSpendService,
    AdminUserService,
    AdminVisualExportImportService,
    AppService,
    AssetLockService,
    BusinessUserService,
    ContentAccessApiService,
    ContentSelectorApiService,
    CustomDatasetDropdownService,
    CustomDatasetService,
    DashboardService,
    DataModelAdminApiService,
    DataModelUserApiService,
    DataQueryService,
    EnterpriseUserService,
    FileService,
    FileUploadConfigService,
    GainsightPXService,
    ItemCategoryService,
    JobService,
    LocaleService,
    OrganisationService,
    PivotStudioService,
    ProductService,
    PublishedReportService,
    SampleVisualService,
    ScheduleService,
    SiteContentService,
    SystemInfoService,
    UserDashboardService,
    UserDatasetService,
    UserPreferencesService,
    UserScheduleService,
    UserService,
    UserSettingsService,
    UserStateService,
    UserVisualService,
    VisualExportService,
    VisualService,
    AIAgentService,
    DataRelationshipMappingUserApiService,
    AdminDataRelationshipMappingService
} from './api.services';
import { SupportService } from './support.service';

// Non-admin services
@NgModule({
  providers: [
    AppService,
    DashboardService,
    DataQueryService,
    OrganisationService,
    UserService,
    VisualService,
    SampleVisualService,
    ScheduleService,
    UserDashboardService,
    ItemCategoryService,
    ProductService,
    UserStateService,
    UserScheduleService,
    UserVisualService,
    JobService,
    PivotStudioService,
    LocaleService,
    UserSettingsService,
    SiteContentService,
    SystemInfoService,
    SupportService,
    CustomDatasetService,
    UserDatasetService,
    CustomDatasetDropdownService,
    UserPreferencesService,
    FileService,
    VisualExportService,
    FileUploadConfigService,
    PublishedReportService,
    EnterpriseUserService,
    BusinessUserService,
    AssetLockService,
    DataModelUserApiService,
    GainsightPXService,
    ContentSelectorApiService,
    ContentAccessApiService,
    AIAgentService,
    DataRelationshipMappingUserApiService
  ]
})
export class AppApiModule { }

// Admin services
@NgModule({
  providers: [
    AdminService,
    AdminOrganisationService,
    AdminDashboardService,
    AdminProductService,
    AdminProductUpgradeService,
    AdminUserService,
    AdminProductVersionService,
    AdminVisualExportImportService,
    AdminSpendService,
    AdminSiteContentService,
    AdminOrganisationSecretService,
    AdminFileUploadConfigService,
    AdminOrganisationSettingsService,
    AdminClientCustomizationService,
    AdminETLStatusService,
    AdminExtendedDatasetManagerService,
    AdminCacheService,
    DataModelAdminApiService,
    AdminDataModelService,
    AdminJobInfoService,
    AdminGainsightPXService,
    AdminDashboardsExportImportService,
    AdminDataRelationshipMappingService
  ]
})
export class AppAdminApiModule { }
